





















































































import LanguageSwitcher from 'components/LanguageSwitcher.vue'
import OAuth from 'components/OAuth.vue'
import Profiles from 'components/Profiles.vue'
import { QForm } from 'quasar'
import { submitLoginForm } from 'src/helpers'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { LoginProfile } from '../types'

@Component({
  components: {
    Profiles,
    LanguageSwitcher,
    OAuth
  }
})
export default class Login extends Vue {
  @Prop({ type: Array, required: true }) readonly profiles!: LoginProfile[]

  login: string = ''

  password: string = ''

  isHiddenPassword: boolean = true

  rememberMe: boolean = true

  errors: Record<string, string[]> = {}

  loading: boolean = false

  get challenge () {
    return this.$route.query.login_challenge
  }

  submitForm () {
    const csrfToken = this.$q.cookies.get('xsrf')
    const formData = {
      login: this.login,
      password: this.password,
      rememberMe: this.rememberMe ? 1 : 0,
      force: this.password ? 1 : 0,
      challenge: this.challenge,
      _csrf: csrfToken
    }

    this.loading = true

    this.$axios.post('/login/validate', formData, {
      headers: {
        'CSRF-Token': csrfToken
      },
      withCredentials: true
    }).then(async ({ data }) => {
      if (data.loginProfiles && data.loginProfiles.length) {
        this.$emit('loginAs', data.loginProfiles[0])
      } else if (data.errors) {
        this.errors = data.errors
        await (this.$refs.loginForm as QForm).validate()
      } else if (data.ok) {
        this.errors = {};
        (this.$refs.loginForm as QForm).resetValidation()
        submitLoginForm(formData)
      }
    }).catch((e) => {
      this.errors = {
        network: e.message
      }
    }).finally(() => {
      this.loading = false
    })
  }
}
